import { ReactElement } from 'react';
import Button from './Button';

interface Props {
  id: string;
  title: string;
  children: ReactElement;
  actionsFooter?: boolean;
  confirmButtonActive?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onClickSuccess?: () => void;
  onClickDanger?: () => void;
  loadButton?: boolean;
  size?: 'lg' | 'sm' | 'xl';
}

const Modal = ({
  id, title, children, actionsFooter, confirmButtonActive, confirmButtonText,
  cancelButtonText, onClickSuccess, onClickDanger, loadButton, size,
}: Props) => (
  <div
    className="modal fade"
    id={id}
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    role="dialog"
    aria-hidden="true"
    style={{ display: 'none' }}
  >
    <div className={`modal-dialog modal-${size}`} role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            {title}
          </h5>
          <Button
            type="button"
            className="close"
            id={`modal-close-${id}`}
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </Button>
        </div>
        <div className="modal-body">
          {children}
        </div>
        {actionsFooter && (
          <div className="modal-footer">
            {cancelButtonText && (
              <Button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={onClickDanger}
              >
                {cancelButtonText}
              </Button>
            )}
            {confirmButtonText && (
              <Button
                type="submit"
                className="btn btn-primary d-flex align-items-center"
                load={loadButton}
                onClick={onClickSuccess}
                disabled={confirmButtonActive}
              >
                {confirmButtonText}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
);

Modal.defaultProps = {
  size: undefined,
  actionsFooter: true,
  confirmButtonActive: undefined,
  confirmButtonText: undefined,
  cancelButtonText: undefined,
  onClickSuccess: undefined,
  onClickDanger: undefined,
  loadButton: undefined,
};

export default Modal;
